import React from 'react'

export const Loading = () => {
  return (
    <div>Loading...</div>
  )
}

